import React from 'react';
function ServicesHomeOne({ className }) {
    return (
        <section className={`appie-service-area pt-90 pb-100 ${className}`} id="service">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <div className="appie-section-title text-center">
                            <h3 className="appie-title">
                            Supermedic | Healthcare Jobs Without Borders

                            </h3>
                            <p>Connect to locum, contract, and permanent jobs locally and internationally. Supermedic empowers doctors, nurses, and allied health professionals to shape their career, their way.</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-3 col-md-6">
                        <div
                            className="appie-single-service text-center mt-30 wow animated fadeInUp"
                            data-wow-duration="2000ms"
                            data-wow-delay="200ms"
                        >
                            <div className="icon d-flex justify-content-center align-items-center" style={{height: '120px'}}>
                                <span role="img" aria-label="Malaysia flag" style={{fontSize: '96px'}}>🇲🇾</span>
                            </div>
                            <h4 className="appie-title">Malaysia</h4>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div
                            className="appie-single-service text-center mt-30 wow animated fadeInUp"
                            data-wow-duration="2000ms"
                            data-wow-delay="400ms"
                        >
                            <div className="icon d-flex justify-content-center align-items-center" style={{height: '120px'}}>
                                <span role="img" aria-label="Singapore flag" style={{fontSize: '96px'}}>🇸🇬</span>
                            </div>
                            <h4 className="appie-title">Singapore</h4>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div
                            className="appie-single-service text-center mt-30 wow animated fadeInUp"
                            data-wow-duration="2000ms"
                            data-wow-delay="600ms"
                        >
                            <div className="icon d-flex justify-content-center align-items-center" style={{height: '120px'}}>
                                <span role="img" aria-label="Indonesia flag" style={{fontSize: '96px'}}>🇮🇩</span>
                            </div>
                            <h4 className="appie-title">Indonesia</h4>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div
                            className="appie-single-service text-center mt-30 wow animated fadeInUp"
                            data-wow-duration="2000ms"
                            data-wow-delay="800ms"
                        >
                            <div className="icon d-flex justify-content-center align-items-center" style={{height: '120px'}}>
                                <span role="img" aria-label="Philippines flag" style={{fontSize: '96px'}}>🇵🇭</span>
                            </div>
                            <h4 className="appie-title">Philippines</h4>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ServicesHomeOne;
